import * as React from "react";
const HeartSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#EF4136"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.993 3.136C8.993.798 5.66.17 3.155 2.31s-2.858 5.719-.89 8.25c1.635 2.105 6.585 6.544 8.207 7.98.182.162.272.242.378.274a.504.504 0 0 0 .286 0c.106-.032.197-.112.378-.273 1.623-1.437 6.573-5.876 8.208-7.98 1.967-2.532 1.658-6.133-.89-8.251-2.549-2.118-5.84-1.512-7.839.826Z"
      clipRule="evenodd"
    />
  </svg>
);
export default HeartSVG;
